import type { I_PointOfContact } from '../interfaces'
import { ListNames } from '../config/configuration'
import { rhybusRListsHttp } from '../api/rhybus-list-http'

interface I_POCRaw {
  ID: number
  Id: number
  Title: string
  PointOfContact?: string
  DutyTitle?: string
  PhoneNumber?: string
  IsArchived: boolean
  IsDeleted?: boolean
  IsPublic?: boolean
  ItemCreated?: string
  ItemModified?: string
}

export const getPOCData = async (): Promise<I_PointOfContact[]> => {
  try {
    const list = await rhybusRListsHttp().getList(ListNames.POINT_OF_CONTACT)
    const raw = [...(await list.query().orderBy([{ orderBy: 'Title', ascending: true }]).get<I_POCRaw>())]
    return (raw ?? [])
      .filter((item) => item.IsArchived === false)
      .map((item) => ({
        ...item,
        ContactName: item.PointOfContact?.trim() ?? '',
        ContactTitle: '',
        ContactEmail: item.Title ?? '',
        ContactPhone: item.PhoneNumber ?? '',
      } as unknown as I_PointOfContact))
  } catch (error) {
    console.error('Failed to fetch Points of Contact:', error)
    return []
  }
}
